module.exports = __webpack_public_path__ + "img/img-team.de2b3e42.png";